import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SystemService } from '../../services/system.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class CandidateService {

  constructor(private http: HttpClient, private system: SystemService, private translate: TranslateService) { }

  getCandidates(): Observable<any[]> {
    return this.http.get<any[]>(this.system.apiURL + "/candidates");
  }

  processCandidateCV(recruitmentCandidateId): Observable<any[]> {
    return this.http.get<any[]>(this.system.apiURL + "/candidates/" + recruitmentCandidateId + "/process");
  }

  getCandidatesByCompany(): Observable<any[]> {
    return this.http.get<any[]>(this.system.apiURL + "/candidates/company");
  }

  addCandidate(candidate: any): Observable<any> {
    return this.http.post<any>(this.system.apiURL + "/candidates", candidate);
  }

  updateCandidate(candidate: any): Observable<any> {
    const url = `${this.system.apiURL + "/candidates"}/${candidate.id}`;
    return this.http.put<any>(url, candidate);
  }

  deleteCandidate(id: number): Observable<void> {
    const url = `${this.system.apiURL + "/candidates"}/${id}`;
    return this.http.delete<void>(url);
  }

  updateCandidateStatus(candidateId: number, status: string, recruitmentId: number): Observable<any> {

    const data = {
      recruitment_id: recruitmentId,
      status: status,
      lang: this.translate.getDefaultLang()
    }; 

    return this.http.put(`${this.system.apiURL}/candidates/${candidateId}/status`, data);
  }

  generateOffer(positionName: string) {
    return this.http.get(`${this.system.apiURL}/candidates/generate-offer`, {
        params: {
            lang: this.translate.getDefaultLang(),
            positionName: positionName
        }
    });
  }
  
  sendOffer(offerData: any) {
    return this.http.post(`${this.system.apiURL}/candidates/send-offer`, offerData);
  }  
}
